import { CloseOutlined } from '@mui/icons-material';
import { Grid, IconButton, Typography, useTheme } from '@mui/material';
import { Visitor } from 'graphql/generated/graphqlTypes';

interface Props {
  index: number;
  keyManager: Visitor;
  onRemove: () => void;
}

const KeyManagerRow = ({ index, keyManager, onRemove }: Props) => {
  const theme = useTheme();

  return (
    <Grid
      id={`key-manager-row-${index}`}
      container
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      padding="16px"
      sx={{ backgroundColor: theme.custom.background.level2 }}
    >
      <Grid container direction="column" spacing={0}>
        <Typography variant="body1">{keyManager.name}</Typography>
        <Typography variant="body2" color="textSecondary">
          {keyManager.email}
        </Typography>
      </Grid>
      <IconButton id={`key-manager-row-${index}-remove-button`} onClick={onRemove} style={{ padding: '4px' }}>
        <CloseOutlined />
      </IconButton>
    </Grid>
  );
};

export default KeyManagerRow;
